<template>
    <div class="guarantee">

         <div class="container">

                <h3>动力保障</h3>
 <div class="icons">
   <el-card   v-for="(item, index) in guaranteeAlbums"
        :key="index"
        style="width: 40.625rem; height: fit-content; margin-bottom: 3.75rem; display:inline-block;text-align: center;justify-content: center;background-color: #ffffff;"
        shadow="never" :body-style="{ padding: '0px' }">
   <div>
        <img
          :src="item.url"
          alt
          style="width:31.9375rem; height: 16.4375rem;margin-top: 3.0625rem;margin-bottom:3.0625rem;"
        />
        <span style="font-size:1.5rem;line-height:3rem;font-weight: 600;text-align: center;display: block;margin-bottom: 1.625rem;">{{ item.title }}</span>
        <!-- <div v-html="item.desc" style="font-size:1.5rem; line-height: 2.25rem;margin-bottom:3.0625rem;color: #777777;"></div>   -->
      </div>
   </el-card>

    </div>
         </div>
    </div>
</template>

<style scoped>
.guarantee{
    text-align: center;
}
.el-card{
  border-radius: 1.25rem
}
.container{
    width: 100%;
    height: fit-content;
    padding-bottom: .625rem;
    background-color:rgba(180,214,242, 0.2);
    display: inline-block;
}
.icons{
  text-align: center;
  width:100%;
}

h3 {

  padding-top: 4.375rem;
  padding-bottom: 3.125rem;
  color: #1A1A1A;
  font-size: 2.25rem;
  line-height: 3.75rem;
}
</style>

<script>
export default {

    data () {
    return {
     msg: '动力保障',
     guaranteeAlbums:[
        {
          url: require("../../assets/welfare/album01_0.png"),
          title: "五险一金",
          desc: "公司为所有员工缴纳五险一金（养老、医疗、工伤、失业<br/>、生育保险及住房公积金），并购买高额的商业补充保险<br/>（意外险、门诊险、定期寿险等）。",
        },
        {
          url: require("../../assets/welfare/album01_1.png"),
          title: "免费体检",
          desc: "公司倡导“健康生活，快乐工作”，<br/>每年定期选取高端体检机构，<br/>免费为员工提供全面、正规、舒适的体检服务。",
        },
        // {
        //   url: require("../../assets/welfare/album01_2.png"),
        //   title: "健身Club",
        //   desc: "我运动，我快乐。健身一小步，健康一大步。<br/>为了让员工更好地放松身心公司为员工准备了五星级<br/>服务健身会所，每周每员工享受1次免费健身福利，<br/>体验健身器材、瑜伽、有氧舞蹈、健身操、游泳等锻炼。",
        // },
     ]
    };
    },
    onActivated (){

    }
}
</script>



// WEBPACK FOOTER //
// src/components/mobile/Guarantee.vue